<template>
    <CRow>
        <CCol col="12" lg="8">
            <CCard v-if="entity">
                <CCardHeader>
                    <span class="font-bold">{{ entity.title }}</span>
                </CCardHeader>

                <CCardBody>
                    <CategoriesListTable :data="[entity]" :show-filters="false" />
                </CCardBody>

                <CCardFooter>
                    <div class="flex">
                        <CButton
                            color="light"
                            @click="goBack">Назад</CButton>

                        <CButton
                            color="primary"
                            class="ml-auto"
                            @click="editEntity">Редактировать</CButton>

                        <CButton
                            color="danger"
                            class="ml-4"
                            @click="deleteEntity">Удалить</CButton>
                    </div>
                </CCardFooter>
            </CCard>
        </CCol>

        <CategoriesUpsertDialog
            ref="upsertDialog"
            :entity="entity"
            @success="getCategory"
        />

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить категорию? Это действие нельзя будет отменить."
            @confirm="deleteCategory"
        />
    </CRow>
</template>

<script>
    import AppConfirmDialog from '@/components/AppConfirmDialog'
    import CategoriesListTable from '@/components/CategoriesListTable'
    import CategoriesUpsertDialog from '@/components/CategoriesUpsertDialog'

    export default {
        name: 'Category',

        components: {
            AppConfirmDialog,
            CategoriesListTable,
            CategoriesUpsertDialog,
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.cameFromCategoriesListPage = from.fullPath.includes('categories');
            })
        },

        data: () => ({
            cameFromCategoriesListPage: false,
            entity: undefined,
        }),

        computed: {
            categoryId() {
                return this.$route.params.id
            },
        },

        async created() {
            await this.getCategory()
        },

        methods: {
            editEntity() {
                this.$refs.upsertDialog.open()
            },

            deleteEntity() {
                this.$refs.confirmDialog.open()
            },

            async getCategory() {
                try {
                    const { data } = await this.axios.get(`/categories/${this.categoryId}`)
                    this.entity = data
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            async deleteCategory() {
                try {
                    await this.axios.delete(`/categories/${this.$route.params.id}`)
                    this.goBack()
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка удаления.');
                }
            },

            goBack() {
                this.cameFromCategoriesListPage
                    ? this.$router.go(-1)
                    : this.$router.push({ path: '/categories' })
            },
        }
    }
</script>
